<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Media Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek e-posta adresi benzersiz olmalıdır.</span
              >
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-col cols="12" class="mb-2 mt-2">
        <b-card class="mb-3" title="Abonelik Ekle">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <b-form-group label="İzin Türü" label-for="selectedPermissionType">
                    <validation-provider
                      #default="{ errors }"
                      :rules="{
                        required: true,
                      }"
                      name="İzin Türü"
                    >
                      <v-select
                        id="selectedPermissionType"
                        v-model="selectedPermissionType"
                        label="name"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="permissionTypes"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="İzin Durumu" label-for="selectedPermissionStatus">
                    <validation-provider
                      #default="{ errors }"
                      :rules="{
                        required: true,
                      }"
                      name="İzin Durumu"
                    >
                      <v-select
                        id="selectedPermissionStatus"
                        v-model="selectedPermissionStatus"
                        label="name"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="permissionStatuses"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="İzin Kanağı" label-for="selectedPermissionSource">
                    <validation-provider
                      #default="{ errors }"
                      :rules="{
                        required: true,
                      }"
                      name="İzin Kanağı"
                    >
                      <v-select
                        id="selectedPermissionSource"
                        v-model="selectedPermissionSource"
                        label="name"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="permissionSources"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Ad" label-for="name">
                    <validation-provider #default="{ errors }" rules="required" name="Ad">
                      <b-form-input id="name" v-model="name" placeholder="Ad" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Soyad" label-for="surname">
                    <validation-provider
                      #default="{ errors }"
                      rules="required"
                      name="Soyad"
                    >
                      <b-form-input id="surname" v-model="surname" placeholder="Soyad" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="E-Posta" label-for="email">
                    <validation-provider
                      #default="{ errors }"
                      rules="required|email"
                      name="E-Posta"
                    >
                      <b-form-input
                        id="email"
                        v-model="email"
                        placeholder="E-Posta"
                        type="email"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Doğum Tarihi" label-for="birthday">
                    <b-form-input locale="tr" v-model="birthday" type="date" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Telefon" label-for="phone">
                    <b-form-input locale="tr" v-model="phone" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" class="mt-5">
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postNewsletters(false, false)"
                  >
                    <b-spinner v-if="spinner === true" small />
                    {{ spinner === true ? "Kaydediliyor" : "Kaydet" }}
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </validation-observer>
    <b-row>
      <b-col cols="12" class="mb-2 mt-2">
        <b-card class="mb-3" title="Abonelikler">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col md="4"> </b-col>
                <b-col md="4">
                  <div class="mb-2">
                    <b-form-group label="Başlangıç Tarihi" label-for="startDate">
                      <b-form-datepicker
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        locale="tr"
                        v-model="startDate"
                      />
                    </b-form-group>
                  </div>
                  <div class="mb-2">
                    <b-form-group label="Bitiş Tarihi" label-for="endDate">
                      <b-form-datepicker
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        locale="tr"
                        v-model="endDate"
                      />
                    </b-form-group>
                  </div>
                  <div class="mb-2 d-flex justify-content-center align-items-center">
                    <b-button
                      class="float-right"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-success"
                      target="_blank"
                      v-on:click="getNewsletters(1)"
                    >
                      Filtrele
                    </b-button>
                  </div>
                </b-col>
                <b-col md="4"> </b-col> </b-row
            ></b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="d-flex justify-content-center align-items-center">
                <table class="table b-table table-responsive w-auto">
                  <thead>
                    <th>ID</th>
                    <th>E-POSTA</th>
                    <th>AD SOYAD</th>
                    <th>D.TARİHİ</th>
                    <th>TELEFON</th>
                    <th>İZİN TİPİ</th>
                    <th>İZİN DURUMU</th>
                    <th>İZİN KAYNAĞI</th>
                    <th>DURUM</th>
                    <th>OLUŞTURMA TARİHİ</th>
                  </thead>
                  <tbody>
                    <tr v-for="newsletter in newsletters" :key="newsletters.id">
                      <td>{{ newsletter.id }}</td>
                      <td>{{ newsletter.email }}</td>
                      <td>{{ newsletter.name }} {{ newsletter.surname }}</td>
                      <td>{{ newsletter.birthday }}</td>
                      <td>{{ newsletter.phone }}</td>
                      <td>{{ newsletter.permissionType }}</td>
                      <td>{{ newsletter.permissionStatus }}</td>
                      <td>{{ newsletter.permissionSource }}</td>
                      <td>{{ newsletter.subscribed == true ? 'ONAYLANDI' : 'ONAYLANMADI' }}</td>
                      <td>{{ newsletter.createdAt }}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <th>ID</th>
                    <th>E-POSTA</th>
                    <th>AD SOYAD</th>
                    <th>D.TARİHİ</th>
                    <th>TELEFON</th>
                    <th>İZİN TİPİ</th>
                    <th>İZİN DURUMU</th>
                    <th>İZİN KAYNAĞI</th>
                    <th>DURUM</th>
                    <th>OLUŞTURMA TARİHİ</th>
                  </thead>
                </table>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="d-flex justify-content-center align-items-center">
                <b-pagination
                  :value="1"
                  :total-rows="rows"
                  :per-page="12"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => getNewsletters(value)"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div> </b-col
          ></b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BFormFile,
  BCardText,
  BFormGroup,
  BFormInput,
  BPagination,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
  BFormDatepicker,
} from "bootstrap-vue";

import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
import vSelect from "vue-select";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BAlert,
    BBadge,
    BButton,
    BAvatar,
    BFormFile,
    BCardText,
    BFormGroup,
    BFormInput,
    BPagination,
    BButtonGroup,
    BButtonToolbar,
    BListGroupItem,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      rows: 100,
      medias: [],
      locale: this.$i18n.locale,
      baseUrl: settings.apiBaseUrl,
      currentPage: 1,
      newsletters: [],
      startDate: null,
      endDate: null,
      email: null,
      name: null,
      surname: null,
      birthday: null,
      phone: null,
      permissionTypes: ["E-POSTA"],
      selectedPermissionType: null,
      permissionStatuses: ["ONAY", "RED"],
      selectedPermissionStatus: null,
      permissionSources: ["HS_ISLAK_IMZA"],
      selectedPermissionSource: null,
      spinner: false,
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal, oldVal) {
        this.getNewsletters(newVal);
      },
      deep: true,
    },
  },
  methods: {
    copy(url) {
      navigator.clipboard.writeText(url).then(
        function () {
          console.log("Copied!");
        },
        function () {
          console.log("Copy error");
        }
      );
    },
    handleMediaUpload(event) {
      setTimeout(() => {
        this.postMedias();
      }, 1000);
    },
    getNewsletters(page) {
      endpoints
        .getNewsletters(page, this.startDate, this.endDate, this.$i18n.locale, () => {})
        .then((data) => {
          this.newsletters = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postNewsletters() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let form = {
            name: this.name,
            surname: this.surname,
            birthday: this.birthday,
            phone: this.phone,
            email: this.email,
            permissionType: this.selectedPermissionType,
            permissionStatus: this.selectedPermissionStatus,
            permissionSource: this.selectedPermissionSource,
          };
          endpoints
            .postNewsletters(form, this.$i18n.locale, () => {})
            .then((data) => {
              this.newsletters = [];
              // this.name = null;
              // this.surname = null;
              // this.birthday = null;
              // this.phone = null;
              // this.email = null;

              if (data.response.status == false) {


               this.$swal({
                  icon: "warning",
                  title: "UYARI!",
                  text: "Abone zaten mevcut.",
                  customClass: {
                    confirmButton: "btn btn-warning",
                  },
                });
                this.spinner = false;


              } else {
                this.getNewsletters(this.currentPage);
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Yeni abone eklendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                this.spinner = false;
              }
            })
            .catch((err) => {
              console.log(err);
              this.spinner = false;
            });
        }
      });
    },
  },
  mounted() {
    this.getNewsletters(this.currentPage);
    this.selectedPermissionType = this.permissionTypes[0];
    this.selectedPermissionSource = this.permissionSources[0];
    this.selectedPermissionStatus = this.permissionStatuses[0];
  },
  setup() {},
};
</script>
